import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/about/home-icon.svg")